export function mapRulesToGroups(query) {
  if (!query || !Array.isArray(query.rules)) return;

  const flatRules = query.rules.filter(rule => !rule.rules);
  const nestedGroups = query.rules.filter(rule => Array.isArray(rule.rules) && rule.rules.length > 0);

  const groups = [];

  if (flatRules.length > 0) {
    groups.push({
      operator: query.combinator,
      conditions: flatRules.map(({ field, operator, value }) => ({
        field,
        operator,
        value
      }))
    });
  }

  nestedGroups.forEach(group => {
    groups.push({
      operator: group.combinator,
      conditions: group.rules.map(({ field, operator, value }) => ({
        field,
        operator,
        value
      }))
    });
  });

  return groups;
}

export function mapGroupsToRules(input) {
  if (!input) return;

  const { operator: topCombinator, groups } = input;

  const rules = [];

  groups?.forEach(group => {
    const { operator, conditions } = group;

    if (topCombinator === operator) {
      rules.push(...conditions);
    } else {
      rules.push({
        combinator: operator,
        rules: [...conditions]
      });
    }
  });

  return { combinator: topCombinator, rules };
}
